import React from 'react';

export const WeBuyBenefits: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cash Offers',
      description: 'Get a fair all-cash offer within 24 hours. No financing contingencies or delays.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Fast Closing',
      description: 'Close on your timeline. We can complete the transaction in as little as 7 days.'
    },
    {
      icon: 'ri-tools-line',
      title: 'No Repairs Needed',
      description: 'Sell your property as-is. We buy buildings in any condition, no renovations required.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'No Commissions',
      description: 'Keep more money in your pocket. No agent fees, no hidden costs, no surprises.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Confidential Process',
      description: 'Discreet transactions that protect your privacy and your tenants.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Flexible Terms',
      description: 'We work with your situation. Seller financing options available if preferred.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Why Sell to Us</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We make selling your apartment building simple, fast, and stress-free
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 text-white rounded-lg mb-6">
                <i className={`${benefit.icon} text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
